/* eslint-disable prefer-const */
import type { HasSteps } from './types.no-deps'
import { getAllElements } from './element.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { filter, map, reduce, uniq } from '../../lib/functional/array.no-deps'
import { isLoopElement, isUnitSelectElement } from './typeGuards.no-deps'
import type { UnitWithTypeAndParents } from '../units/types.no-deps'
import { flatten } from '../../lib/array.no-deps'
import { dictMerge, dictValues, emptyDict } from '../../lib/functional/dictionary.no-deps'
import { getUnitSelectUnitIds } from './UnitSelectIds.no-deps'
import { anyPass } from '../../lib/functional/predicate.no-deps'
import type { ParentIsUserSelectable } from './UnitFilter.no-deps'

export type FlowUnitIds = Record<string, number[]>

export function getFlowUnitIds(allUnits: UnitWithTypeAndParents[], flow: HasSteps): FlowUnitIds {
    let unitsLookup: Record<number, UnitWithTypeAndParents> = {}

    allUnits.forEach((unit) => {
        unitsLookup[unit.id] = unit
    })
    return pipe(
        getAllElements(flow),
        filter(anyPass([isUnitSelectElement, isLoopElement])),
        map((element) => {
            if (element.type === 'unit-select') {
                return { [element.id]: getUnitSelectUnitIds(allUnits, unitsLookup, element) }
            }
            if (element.type === 'loop') {
                const unitTypes = element.unitFilters
                    .filter((filter): filter is ParentIsUserSelectable => filter.type === 'ParentIsUserSelectable')
                    .map((filter) => filter.unitType)
                const units = allUnits.filter((unit) => unitTypes.includes(unit.type))
                return { [element.id]: units.map((unit) => unit.id) }
            }
        }),
        reduce(emptyDict(), dictMerge)
    )
}

export const getUnitsIdsToFetch = (flowUnitIds: FlowUnitIds): number[] => {
    return pipe(flowUnitIds, dictValues, flatten, uniq)
}
